import { createFileRoute } from "@tanstack/react-router";

import { WalletHistoryDetail } from "@/features/my/settings/account/billing/wallet/wallet-history/wallet-history-detail";

export const Route = createFileRoute(
  "/(member)/(protected)/my/settings/account/billing/wallet/history_/$walletItemId",
)({
  component: WalletHistoryDetail,
});
